import React, { Component } from "react";
import { getS3FormsFileUrl } from "../../services/submissionService";
import greenCheck from "../../Images/green-check-mark-icon-tick.png";

export default class ProposalDocSection extends Component {
  state = {};

  addProgress = (id) => {
    this.setState((previousState) => {
      return {
        progress: { ...previousState.progress, [id]: 1 },
      };
    });
  };

  removeProgress = (id) => {
    let currentProgressState = this.state.progress;
    delete currentProgressState[id];
    this.setState({ progress: currentProgressState });
  };

  removeOlderFiles = (files) => {
    let output = files.filter((file) => {
      let evaluation = true;
      const fileName = file.Key.split("/")[file.Key.split("/").length - 1];

      // Filter out items without a period (folders)
      if (!fileName.includes(".")) {
        evaluation = false;
      }

      // Get base name (parts before the last underscore which typically contains the date)
      const fileNameParts = fileName.split("_");
      const fileBaseName = fileNameParts.slice(0, -1).join("_");

      files.forEach((element) => {
        const elementFileName = element.Key.split("/")[element.Key.split("/").length - 1];
        const elementFileNameParts = elementFileName.split("_");
        const elementBaseName = elementFileNameParts.slice(0, -1).join("_");

        // If two files have the same base name (excluding date), keep only the newer one
        if (
          fileBaseName === elementBaseName &&
          file.LastModified !== element.LastModified
        ) {
          let date1 = new Date(file.LastModified.replace(/-/g, "/"));
          let date2 = new Date(element.LastModified.replace(/-/g, "/"));
          if (date1 < date2) {
            evaluation = false;
          }
        }
      });

      return evaluation;
    });

    return output;
  };

  render() {
    const registrations = this.props.values?.registrations 
      ? JSON.parse(this.props.values.registrations.replace(/'/g, '"'))
      : [];

    const { supplementalFiles, checkedItems, downloadedItems } = this.props;
    return (
      <div
        style={{
          width: "100%",
        }}
      >
        <div className="card-body" style={{ padding: "10px 20px 0" }}>
          <div>
            <h5 className="card-title" style={{ display: "inline-block", color: "#385EA4" }}>
              {this.props.title}{" "}
              {this.props.loading && (
                <div
                  className="spinner-border"
                  role="status"
                  style={{ height: "18px", width: "18px" }}
                />
              )}
            </h5>
          </div>

          {registrations.length > 0
            ? registrations.map((r, index) => (
                <div key={`${index}_${r}`}>
                  <span>{this.props.qualification}</span>
                  <table
                    className="table table-sm"
                    style={{ tableLayout: "fixed" }}
                  >
                    <tbody style={{ width: "100%" }}>
                      {this.props.files &&
                        this.removeOlderFiles(this.props.files).map(
                          (f, index) => (
                            <tr
                              key={index}
                              className="row col-12"
                              style={{ margin: "0", padding: "0" }}
                            >
                              <th
                                className="col-sm-1"
                                style={{ display: "flex" }}
                              >
                                <span
                                  style={{
                                    height: "22px",
                                    width: "22px",
                                    display: "inline-flex",
                                    margin: "auto 5px",
                                  }}
                                >
                                  {index + 1}
                                </span>
                                <div
                                  style={{
                                    height: "22px",
                                    width: "22px",
                                    display: "inline-flex",
                                    margin: "auto 5px",
                                  }}
                                >
                                  <input
                                    disabled={this.props.downloadAllInProgress}
                                    onChange={(e) =>
                                      this.props.handleToggleFile(f, e)
                                    }
                                    className="form-check-input"
                                    type="checkbox"
                                    name="checkbox"
                                    id={`checkbox_${f}`}
                                    checked={
                                      checkedItems[
                                        `${
                                          f.Key.split("/")[
                                            f.Key.split("/").length - 1
                                          ]
                                        }`
                                      ] || ""
                                    }
                                    style={{
                                      margin: "auto",
                                      height: "20px",
                                      width: "20px",
                                    }}
                                  />
                                </div>
                              </th>
                              <td
                                style={{
                                  wordWrap: "breakWord",
                                  width: "65vw",
                                }}
                                className="col-md-9"
                              >
                                <button
                                  style={{
                                    background: "none",
                                    border: "none",
                                    textAlign: "left",
                                    outline: "none",
                                  }}
                                  onClick={async () => {
                                    let url = await getS3FormsFileUrl(
                                      f.Key.replace("public/", "")
                                    );
                                    this.props.downloadURL(
                                      url,
                                      f.Key.split("/")[
                                        f.Key.split("/").length - 1
                                      ]
                                    );
                                  }}
                                >
                                  {
                                    f.Key.split("/")[
                                      f.Key.split("/").length - 1
                                    ]
                                  }
                                </button>
                              </td>
                              <td
                                style={{
                                  alignItems: "right",
                                  textAlign: "right",
                                  whiteSpace: "nowrap",
                                  minWidth: "40px",
                                }}
                                className="col-md-2"
                              >
                                {downloadedItems ? (
                                  downloadedItems[
                                    f.Key.split("/")[
                                      f.Key.split("/").length - 1
                                    ]
                                  ] > 0 ? (
                                    <span style={{ margin: "auto 5px" }}>
                                      {downloadedItems[
                                        f.Key.split("/")[
                                          f.Key.split("/").length - 1
                                        ]
                                      ] > 1
                                        ? downloadedItems[
                                            f.Key.split("/")[
                                              f.Key.split("/").length - 1
                                            ]
                                          ]
                                        : null}{" "}
                                      <img
                                        src={greenCheck}
                                        alt="greenCheck.png"
                                        style={{
                                          display: "inline-block",
                                          marginTop: "auto",
                                          marginBottom: "auto",
                                          height: "20px",
                                          width: "20px",
                                        }}
                                      />
                                    </span>
                                  ) : null
                                ) : null}
                                <button
                                  title="Download"
                                  style={{
                                    width: "auto",
                                    height: "35px",
                                    padding: "0 10px",
                                    border: "none",
                                    backgroundColor: "#385EA4",
                                    color: "White",
                                    boxShadow: "none",
                                  }}
                                  className="col btn"
                                  onClick={() => {
                                    const onClickThis = this;
                                    this.addProgress(
                                      f.Key.split("/")[
                                        f.Key.split("/").length - 1
                                      ]
                                    );
                                    this.props.handleDownload(
                                      f.Key,
                                      f.Key.split("/")[
                                        f.Key.split("/").length - 1
                                      ],
                                      function (x) {
                                        const id =
                                          f.Key.split("/")[
                                            f.Key.split("/").length - 1
                                          ];
                                        onClickThis.setState(
                                          (previousState) => {
                                            return {
                                              progress: {
                                                ...previousState.progress,
                                                [id]: x,
                                              },
                                            };
                                          }
                                        );
                                        if (x >= 100) {
                                          onClickThis.removeProgress(
                                            f.Key.split("/")[
                                              f.Key.split("/").length - 1
                                            ]
                                          );
                                        }
                                      }
                                    );
                                  }}
                                >
                                  {this.state.progress ? (
                                    this.state.progress[
                                      f.Key.split("/")[
                                        f.Key.split("/").length - 1
                                      ]
                                    ] ? (
                                      <span
                                        style={{
                                          display: "inline-block",
                                          marginBottom: "3px",
                                          marginRight: "5px",
                                        }}
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      />
                                    ) : null
                                  ) : null}
                                  Download
                                </button>
                              </td>
                            </tr>
                          )
                        )}
                    </tbody>
                  </table>
                  <span>{"Supplemental"}</span>
                  <table
                    className="table table-sm"
                    style={{ tableLayout: "fixed" }}
                  >
                    <tbody>
                      {supplementalFiles &&
                        this.removeOlderFiles(supplementalFiles).map(
                          (f, index) => (
                            <tr
                              key={index}
                              className="row col-12"
                              style={{ margin: "0", padding: "0" }}
                            >
                              <th
                                className="col-sm-1"
                                style={{ display: "flex" }}
                              >
                                <span
                                  style={{
                                    height: "22px",
                                    width: "22px",
                                    display: "inline-flex",
                                    margin: "auto 5px",
                                  }}
                                >
                                  {index + 1}
                                </span>
                                <div
                                  style={{
                                    height: "22px",
                                    width: "22px",
                                    display: "inline-flex",
                                    margin: "auto 5px",
                                  }}
                                >
                                  <input
                                    disabled={this.props.downloadAllInProgress}
                                    onChange={(e) =>
                                      this.props.handleToggleFile(f, e)
                                    }
                                    className="form-check-input"
                                    type="checkbox"
                                    name="checkbox"
                                    id={`checkbox_${f}`}
                                    checked={
                                      checkedItems[
                                        `${
                                          f.Key.split("/")[
                                            f.Key.split("/").length - 1
                                          ]
                                        }`
                                      ] || ""
                                    }
                                    style={{
                                      margin: "auto",
                                      height: "20px",
                                      width: "20px",
                                    }}
                                  />
                                </div>
                              </th>
                              <td
                                style={{
                                  wordWrap: "breakWord",
                                  width: "65vw",
                                  minWidth: "100px",
                                }}
                                className="col-md-9"
                              >
                                <button
                                  style={{
                                    background: "none",
                                    border: "none",
                                    textAlign: "left",
                                    outline: "none",
                                  }}
                                  onClick={async () => {
                                    let url = await getS3FormsFileUrl(
                                      f.Key.replace("public/", "")
                                    );
                                    this.props.downloadURL(
                                      url,
                                      f.Key.split("/")[
                                        f.Key.split("/").length - 1
                                      ]
                                    );
                                  }}
                                >
                                  {
                                    f.Key.split("/")[
                                      f.Key.split("/").length - 1
                                    ]
                                  }
                                </button>
                              </td>
                              <td
                                style={{
                                  alignItems: "right",
                                  textAlign: "right",
                                  whiteSpace: "nowrap",
                                  minWidth: "92px",
                                }}
                                className="col-md-2"
                              >
                                {downloadedItems ? (
                                  downloadedItems[
                                    f.Key.split("/")[
                                      f.Key.split("/").length - 1
                                    ]
                                  ] > 0 ? (
                                    <span style={{ margin: "auto 5px" }}>
                                      {downloadedItems[
                                        f.Key.split("/")[
                                          f.Key.split("/").length - 1
                                        ]
                                      ] > 1
                                        ? downloadedItems[
                                            f.Key.split("/")[
                                              f.Key.split("/").length - 1
                                            ]
                                          ]
                                        : null}{" "}
                                      <img
                                        src={greenCheck}
                                        alt="greenCheck.png"
                                        style={{
                                          display: "inline-block",
                                          marginTop: "auto",
                                          marginBottom: "auto",
                                          height: "20px",
                                          width: "20px",
                                        }}
                                      />
                                    </span>
                                  ) : null
                                ) : null}
                                <button
                                  title="Download"
                                  style={{
                                    width: "auto",
                                    height: "35px",
                                    padding: "0 10px",
                                    border: "none",
                                    backgroundColor: "#385EA4",
                                    color: "White",
                                    boxShadow: "none",
                                  }}
                                  className="col btn"
                                  onClick={() => {
                                    const onClickThis = this;
                                    this.addProgress(
                                      f.Key.split("/")[
                                        f.Key.split("/").length - 1
                                      ]
                                    );
                                    this.props.handleDownload(
                                      f.Key,
                                      f.Key.split("/")[
                                        f.Key.split("/").length - 1
                                      ],
                                      function (x) {
                                        const id =
                                          f.Key.split("/")[
                                            f.Key.split("/").length - 1
                                          ];
                                        onClickThis.setState(
                                          (previousState) => {
                                            return {
                                              progress: {
                                                ...previousState.progress,
                                                [id]: x,
                                              },
                                            };
                                          }
                                        );
                                        if (x >= 100) {
                                          onClickThis.removeProgress(
                                            f.Key.split("/")[
                                              f.Key.split("/").length - 1
                                            ]
                                          );
                                        }
                                      }
                                    );
                                  }}
                                >
                                  {this.state.progress ? (
                                    this.state.progress[
                                      f.Key.split("/")[
                                        f.Key.split("/").length - 1
                                      ]
                                    ] ? (
                                      <span
                                        style={{
                                          display: "inline-block",
                                          marginBottom: "3px",
                                          marginRight: "5px",
                                        }}
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      />
                                    ) : null
                                  ) : null}
                                  Download
                                </button>
                              </td>
                            </tr>
                          )
                        )}
                    </tbody>
                  </table>
                </div>
              ))
            : null}
        </div>
      </div>
    );
  }
}
